import { useContext } from 'react';

import { ConnectModalContext } from '../contexts/connect-modal';

export const useConnectModal = () => {
  return useContext(ConnectModalContext);
};
